module.exports = __webpack_public_path__ + "static/media/trophy_3rd.ac470edb.svg";